export default __webpack_public_path__ + "static/media/search_icon_light.3ab30b85.svg";